import { ref } from 'vue'
import Analytics from '@/services/analytics'

const show = ref(false)
const gameName = ref('')
const introComponent = ref<any>(null)
const gameData = ref<any>({})

export function usePopupGame() {
  const openGame = (name: string, intro: any = null, data: any = {}) => {
    try {
    gameName.value = name
    introComponent.value = intro
    gameData.value = data
    show.value = true
    } catch (error: any) {
      try {
        Analytics.log('game_error_use_popup_game_open', {
          error: error?.message || String(error),
          gameName: name
        })
      } catch (e) {
      }
    }
  }

  const closeGame = () => {
    try {
    show.value = false
    gameName.value = ''
    introComponent.value = null
    gameData.value = {}
    } catch (error: any) {
      try {
        Analytics.log('game_error_use_popup_game_close', {
          error: error?.message || String(error),
          gameName: gameName.value
        })
      } catch (e) {
      }
    }
  }

  return {
    show,
    gameName,
    introComponent,
    gameData,
    openGame,
    closeGame,
  }
}
